import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export interface RegisterLoginData {
  token: string;
  user: {
    matricNumber: string;
  };
}

export type OrderResponse = {
  id: number;
  orderNumber: string;
  orderDate: string;
  customerId: string;
  paymentGateway: string;
  paymentMethod: string;
  paymentReference: string;
  status: number;
  note: string;
};

export const orderData = atom<OrderResponse[]>([]);

// Use safe parsing from localStorage
const storedUser = localStorage.getItem("JHU-Etranscript");
const parsedUser = storedUser ? JSON.parse(storedUser) : undefined;

export const userData = atomWithStorage<RegisterLoginData | undefined>(
  "JHU-Etranscript",
  parsedUser
);

const storedOrderDetails = localStorage.getItem("JHU-order-details");
const parsedOrderDetails = !storedOrderDetails || storedOrderDetails === "undefined"
  ? undefined
  : JSON.parse(storedOrderDetails);
 
export const orderDetails = atomWithStorage<orderDetailsPayload | undefined>(
  "JHU-order-details",
  parsedOrderDetails
);

export const orderNumberAtom = atom<string | null>(null);